import NavBar from './components/NavBar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ProductsSection from './components/ProductsSection';
import FeaturesSection from './components/FeaturesSection';
import TeamSection from './components/TeamSection';
import ContactSection from './components/ContactSection';
import FooterBar from './components/FooterBar';

export default function Home() {
  return (
    <main style={{ scrollBehavior: 'smooth' }}>
      <NavBar />
      <HeroSection />
      <AboutSection />
      <ProductsSection />
      <FeaturesSection />
      <TeamSection />
      <ContactSection />
      <FooterBar />
    </main>
  );
}
